import { useState } from 'react';

import { EMAIL } from '../../utils/constants';
import { usePreviewIframe } from '../Posts/hooks/usePreviewIframe';

import { MessageFormPreview } from '../Posts/MessageFormPreview.jsx';
import { ReminderForm } from './ReminderForm.jsx';

export const ReminderStep = ({ messageForm, tab }) => {
  const [currentPreview, setCurrentPreview] = useState(EMAIL);
  const {
    message,
    setFieldValue,
    handleChange,
    values,
    onSendTest,
    campaignId,
    maxReminderDate,
    publishDate,
    enableReminder,
    setEnableReminder,
  } = messageForm;

  const { updateIframe, iframeRef, iframeSrc } = usePreviewIframe({
    form: messageForm,
    message,
    tab,
  });

  return (
    <>
      <ReminderForm
        message={message}
        values={values}
        handleChange={handleChange}
        setFieldValue={setFieldValue}
        currentPreview={currentPreview}
        setCurrentPreview={setCurrentPreview}
        campaignId={campaignId}
        maxReminderDate={maxReminderDate}
        publishDate={publishDate}
        setEnableReminder={setEnableReminder}
        enableReminder={enableReminder}
        onSendTest={onSendTest}
      />
      <MessageFormPreview
        currentStep={tab}
        demoCustomName={message?.demoCustomName}
        demoName={message?.demoName}
        demoEmail={message?.demoEmail}
        iframeSrc={iframeSrc}
        iframeRef={iframeRef}
        currentPreview={currentPreview}
        setCurrentPreview={setCurrentPreview}
        updateIframe={updateIframe}
        values={values}
        onSendTest={onSendTest}
        enableReminder={enableReminder}
      />
    </>
  );
};
